import SubPageLayout from '../helpers/SubPageLayout';


const ProjectsView = () => {
  

  return (
    <SubPageLayout title="Projects">
      
    </SubPageLayout>
  );
};

export default ProjectsView;